
import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom';
import {  Breadcrumb,Container } from 'semantic-ui-react'
// import Checkout from './Checkout'

export class Header_Bread extends Component {
    constructor(props) {
        super(props);
        // currentStep;
        this.state = {}
        
    }
    handleItemClick = (e, { name }) => this.setState({ activeItem: name })

    // handleItemComp = (e) => this.setState({ Checkout })

    // if (props.currentStep !== 2) 
    // <Menu.Item name='Home' active={activeItem === 'Home'} onClick={this.handleItemClick} style={{marginBottom: '.5em'}} to="/" as={Link}> 
    // Home</Menu.Item>

    render() {
        const { activeItem } = this.state
        return (
            <div>
                <Container textAlign='justified'>
                    <Breadcrumb size='large' >
                        <Breadcrumb.Section link name='Your brief' active={activeItem === 'Your brief'} 
                        onClick={this.handleItemClick} to="/cardlist/card/add" as={Link}>Your Brief</Breadcrumb.Section>
                        <Breadcrumb.Divider icon='right chevron' />
                        <Breadcrumb.Section   name='delivery' active={activeItem === 'delivery'} 
                          >Delivery</Breadcrumb.Section>
                        <Breadcrumb.Divider icon='right chevron' />
                        <Breadcrumb.Section   name='checkout' active={activeItem === 'checkout'} 
                          >Checkout</Breadcrumb.Section>
                        {/* <Breadcrumb.Divider icon='right arrow' /> */}
                        {/* <Breadcrumb.Section active>Personal Information</Breadcrumb.Section> */}
                    </Breadcrumb>

                </Container>


            </div>
        )
    }
}

export default withRouter(Header_Bread)
{/* <Menu.Item name='Projects' active={activeItem === 'Projects'} onClick={this.handleItemClick} style={{marginBottom: '.5em'}} to="/cardlist" as={Link}> 
Projects</Menu.Item> */}